// src/api/m365.js
import axios from './axios';

export const createM365User = async (data) => {
  const payload = {
    displayName: data.displayName,
    userPrincipalName: data.userPrincipalName,
    mailNickname: data.mailNickname || data.userPrincipalName.split('@')[0],
    gmail: data.gmail, // <-- now sending gmail
    passwordProfile: {
      forceChangePasswordNextSignIn: true,
      password: data.password,
    },
  };

  console.log("Sending this payload to the backend:", payload);

  const response = await axios.post('/m365/create-user', payload);
  return response.data;
};

export const listM365Users = async () => {
  const response = await axios.get('/m365/users');
  return response.data.users || response.data || [];
};

export const deleteM365User = async (userId) => {
  const response = await axios.delete(`/m365/delete-user/${userId}`);
  return response.data;
};
